import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (ready && user) navigate("/admin/dashboard"); }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="font-bold tracking-tight text-ink">TRANSPLANT STORY</div>
          <div className="text-[11px] font-mono uppercase tracking-widest text-neutral-400 mt-2">Admin</div>
        </div>
        <form onSubmit={submit} className="bg-white border border-neutral-200 p-8 space-y-5">
          <div>
            <label className="block text-sm font-mono text-neutral-500 mb-2">Email</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full border border-neutral-300 px-4 py-3 outline-none focus:border-rust transition-colors" />
          </div>
          <div>
            <label className="block text-sm font-mono text-neutral-500 mb-2">Password</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full border border-neutral-300 px-4 py-3 outline-none focus:border-rust transition-colors" />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full bg-ink text-white py-3 text-sm font-medium hover:bg-rust transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
